module.exports = __webpack_public_path__ + "2f77bf5f915648bc096d1b4f7ba79ae6.svg";